import { create } from 'zustand';

interface PageHeaderState {
  subTitles: Record<string, string>; // 메뉴ID별 부제목
  setSubTitle: (mnuId: string, subTitle: string) => void;
  clearSubTitle: (mnuId: string) => void;
  syncSubTitlesWithTabs: (openMnuIds: string[]) => void; // 열려있는 탭 기준 동기화
}

/**
 * @desc 페이지 헤더(메뉴명) 옆에 노출할 부제목 상태
 *
 * - 상세화면에서는 hooks/usePageSubTitle 을 통해 사용 (mnuId 자동 바인딩)
 * - 같은 값이면 state를 그대로 반환해 구독자 리렌더(무한 루프)를 막음
 * @author
 * -------------------------------------------------------------------------------------
 *  Date.       author         Description
 * -------------------------------------------------------------------------------------
 * 2026.09.12   jshwang12       신규 생성
 */
export const usePageHeaderStore = create<PageHeaderState>((set) => ({
  subTitles: {},
  setSubTitle: (mnuId, subTitle) =>
    set((state) =>
      state.subTitles[mnuId] === subTitle
        ? state
        : { subTitles: { ...state.subTitles, [mnuId]: subTitle } }
    ),
  clearSubTitle: (mnuId) =>
    set((state) => {
      if (!(mnuId in state.subTitles)) return state;
      const { [mnuId]: _removed, ...rest } = state.subTitles;
      return { subTitles: rest };
    }),
  syncSubTitlesWithTabs: (openMnuIds) =>
    set((state) => {
      const keys = Object.keys(state.subTitles);
      const stale = keys.filter((k) => !openMnuIds.includes(k));
      if (stale.length === 0) return state;
      const next = { ...state.subTitles };
      stale.forEach((k) => delete next[k]);
      return { subTitles: next };
    }),
}));
